import { Navigate } from "react-router-dom";
import { StorageEnums } from "../enums/storageEnums";

const UnAuthGuard = ({ children, ...rest }: any) => {
  const user = localStorage.getItem(StorageEnums.CREDENTIALS);
  return user ? <Navigate to="/dashboard" /> : children;
};

export default UnAuthGuard;
